<template>
    <el-row ref="viewerContainer" class="demo-viewer">
    <!-- <vc-viewer timeline animation @ready="onViewerReady" fullscreenButton> -->
      <vc-overlay-dynamic
        ref="dynamicOverlayRef"
        v-model:current-time="currentTime"
        v-model:start-time="startTime"
        v-model:stop-time="stopTime"
        :dynamic-overlays="dynamicOverlays"
        :clock-range="clockRange"
        :multiplier="multiplier"
        :should-animate="shouldAnimate"
        stopArrivedFlag="position"
        :positionPrecision="0.0001" 
        @update:should-animate="shouldAnimate=$event"
        @stop-arrived="stopArrived"
        @ready="ready"
      >
      <!-- positionPrecision用于比较模型当前所在位置和path中的位置对比，小于positionPrecision时表示当前位置跟path中某位置重合，所以positionPrecision的单位是度 -->
      </vc-overlay-dynamic>
      <!-- <vc-layer-imagery :sort-order="10">
        <vc-imagery-provider-tianditu map-style="vec_c" token="436ce7e50d27eede2f2929307e6b33c0"></vc-imagery-provider-tianditu>
      </vc-layer-imagery> -->
      <vc-collection-point v-if="showStop" :points="stops"></vc-collection-point>
    <!-- </vc-viewer> -->
    <!-- <el-row class="demo-toolbar">
      <el-button type="danger" round @click="unload">销毁</el-button>
      <el-button type="danger" round @click="load">加载</el-button>
      <el-button type="danger" round @click="reload">重载</el-button>
      <el-button type="danger" round @click="viewTopDown">俯视</el-button>
      <el-button type="danger" round @click="viewSide">侧视</el-button> -->
      <!-- <el-button type="danger" round @click="trackOverlay('TRACKED')">默认跟随</el-button>
      <el-button type="danger" round @click="trackOverlay('TP')">俯视跟随</el-button>
      <el-button type="danger" round @click="trackOverlay('FP')">第一人称跟随</el-button>
      <el-button type="danger" round @click="trackOverlay('FREE')">取消跟随</el-button> -->
      <!-- <el-radio-group v-model="radio" @change="startInspection">
        <el-radio :label="0">实时轨迹</el-radio>
        <el-radio :label="1">历史轨迹</el-radio>
      </el-radio-group> -->
      <!-- <el-checkbox v-if="radio === 1" v-model="showStop" style="padding-left: 15px;">显示站点</el-checkbox> -->
    <!-- </el-row> -->
  </el-row>
  </template>
  
  <script>
    import { ref, nextTick, onMounted, onUnmounted, computed, reactive } from 'vue'
    import axios from 'axios'
    import  $bus  from '../bus.ts'
  import { set } from 'lodash'
  
  
  export default {
      name:'DynamicInspection',
      setup() {
        const dynamicOverlays = ref([])
        const dynamicOverlayRef = ref(null)
        const currentTime = ref(null)
        const startTime = ref(null)
        const stopTime = ref(null)
        const clockRange = ref(0)
        // const radio = ref(1)
        const multiplier = ref(1.0)
        const text = ref('yeah')
        const showStop = ref(false)
        const shouldAnimate = ref(false)
        const stops = computed(() => {
          return dynamicOverlays.value.map(v => {
            return v.sampledPositions.map(v => ({ position: v.position, color: 'rgb(255,229,0)' }))
          })?.[0]
        })
        let ledHostListDatas = reactive(null);
        let ledHostPoitions = ref(null);
        // let theTimer ;
         
        const makeHistoryTrajectory = async () => {
          const datas = await Cesium.Resource.fetchJson('/path.json')
          const overlays = []
          const sampledPositions = []
          const positions = []
          startTime.value = new Date(datas[0].time)
          currentTime.value = new Date(datas[0].time)
          stopTime.value = new Date(datas[datas.length - 1].time)
          multiplier.value = 10
          clockRange.value = Cesium.ClockRange.LOOP_STOP
  
          
          const totalSeconds = Cesium.JulianDate.fromDate(stopTime.value).secondsOfDay - Cesium.JulianDate.fromDate(startTime.value).secondsOfDay
          // Store the wheel's rotation over time in a SampledProperty.
          const wheelAngleProperty = new Cesium.SampledProperty(Number)
          let wheelAngle = 0
          
          // console.log("makeHistoryTrajectory is in\n",new Date().toTimeString());
          for (let i = 0; i < datas.length; i++) {
            const data = datas[i]
            sampledPositions.push({
              position: [data.lon, data.lat,2000],
              time: data.time,
              id: data.id
            })
            positions.push([data.lon, data.lat,2000])
            // console.log("makeHistoryTrajectory is in\n",new Date().toTimeString());
            const metersPerSecond = Number(data.speed)
            const wheelRadius = 0.52 //in meters.
            const circumference = Math.PI * wheelRadius * 2
            const rotationsPerSecond = metersPerSecond / circumference
            const time = Cesium.JulianDate.fromIso8601(data.time.replace(' ', 'T'))
  
            wheelAngle += ((Math.PI * 2 * totalSeconds) / datas.length) * rotationsPerSecond
            wheelAngleProperty.addSample(time, wheelAngle)
          }
  
          const rotationProperty = new Cesium.CallbackProperty(function (time, result) {
            const wheelAngle = wheelAngleProperty.getValue(time)
            return Cesium.defined(wheelAngle) ? Cesium.Quaternion.fromAxisAngle(Cesium.Cartesian3.UNIT_X, wheelAngle, result) : new Cesium.Quaternion()
          }, false)
  
          const wheelTransformation = new Cesium.NodeTransformationProperty({
            rotation: rotationProperty
          })
  
          const nodeTransformations = {
            Wheels: wheelTransformation,
            Wheels_mid: wheelTransformation,
            Wheels_rear: wheelTransformation
          }
          // console.log("makeHistoryTrajectory is in\n",new Date().toTimeString());
          overlays.push({
            maxCacheSize: datas.length, // 最大缓存点位数，实时轨迹不要设置太大；历史轨迹要设置得大于总点位数，不然要丢失数据。
            // position:{lng:0 ,lat:0,height:500},
            model: {
              uri: '/model/zhanji.glb' ,//'/model/CesiumDrone.gltf',// 'https://zouyaoji.top/vue-cesium/SampleData/models/GroundVehicle/GroundVehicle.glb',
              scale: 1.5,
              runAnimations: true,
              nodeTransformations: nodeTransformations
            },
            // // 尾迹
            // path: {
            //   leadTime: 10,
            //   trailTime: 10,
            //   resolution: 1,
            //   width: 30,
            //   material: { fabric: { type: 'PolylineGlow', uniforms: { glowPower: 0.1, color: 'yellow' } } }
            // },
            // 标签
            // label: {
            //   text: new Cesium.CallbackProperty(time => {
            //     if (dynamicOverlayRef.value.getOverlays().length) {
            //       const velocityVector = dynamicOverlayRef.value.getOverlays()[0]._velocityVectorProperty.getValue(time, {})
            //       var metersPerSecond = Cesium.Cartesian3.magnitude(velocityVector)
            //       let s = Math.random()>0.5?1:-1;
            //       var kmPerHour = Math.round(metersPerSecond * 3.6) + Math.floor(Math.random() * 10)*s;
            //       if(!shouldAnimate.value){
            //         kmPerHour = 0;
            //       }
            //       return kmPerHour + ' km/h'
            //     }
            //     return 'hello'
            //   }, false),
            //   verticalOrigin: 1,
            //   showBackground: true,
            //   font: '20px sans-serif',
            //   distanceDisplayCondition: [0, 30000],
            //   eyeOffset: { x: 0, y: 180, z: 0 }
            // },
            // 轨迹
            polyline: {
              positions,
              width: 10,
              material: '#69B273',
              depthFailMaterial: '#69B273',
              clampToGround: true
            },
            sampledPositions
          })
          return overlays
        }
  
      
  
        const unload = () => {
          $bus.emit('LEDGpAddr','');
          dynamicOverlayRef.value.unload()
        }
        const load = () => {
          dynamicOverlayRef.value.load()
        }
        const reload = () => {
          if(dynamicOverlayRef.value){
            dynamicOverlayRef.value.reload()
          }
            
        }
        let  _viewer
  
        const ready = ({ viewer, cesiumObject }) => {
          _viewer = viewer
          console.log("ready is in viewer cesiumObject:\n",_viewer,cesiumObject);
          var scene = viewer.scene
          scene.debugShowFramesPerSecond = true
          // shouldAnimate.value = true
          // viewer.flyTo(cesiumObject, {
          //   duration: 3
          // })
          // onRadioChanged(radio.value)
        }
        const startInspection = async e => {
          // timer && clearInterval(timer)
            reload();
            dynamicOverlays.value = await makeHistoryTrajectory()
            console.log("makeHistoryTrajectory is out\n",new Date().toTimeString());
            nextTick(() => {
              // const sampledPositions = dynamicOverlayRef.value.cesiumObject.entities.values[0].sampledPositions
              // const positions = sampledPositions.map(v => {
              //   return Cesium.Cartesian3.fromDegrees(v.position[0], v.position[1])
              // })
              console.log("zoomTo is in\n",new Date().toTimeString());
              _viewer.timeline.zoomTo(_viewer.clock.startTime, _viewer.clock.stopTime)
              // viewTopDown()
              console.log("zoomTo is out\n",dynamicOverlays.value);
              console.log("zoomTo is out\n",dynamicOverlays.value[0]);
              _viewer.trackedEntity = dynamicOverlays.value[0];
              // shouldAnimate.value = true
              
            })
           
        }
        // const onViewerReady = ({ viewer }) => {
        //   _viewer = viewer
        //   onRadioChanged(radio.value)
        // }
  
        const viewTopDown = () => {
          // if (radio.value === 0) {
          //   dynamicOverlayRef.value.zoomToOverlay()
          // } else {
            dynamicOverlayRef.value.zoomToOverlay([], [0, -90, 60000])
          // }
        }
  
        const viewSide = () => {
          // if (radio.value === 0) {
          //   dynamicOverlayRef.value.zoomToOverlay([], [-50, -20, 8000])
          // } else {
          //   dynamicOverlayRef.value.zoomToOverlay([], [-50, -20, 1800])
          // }
        }
  
        const trackOverlay = mode => {
          console.log('dynamicOverlayRef.value = ',dynamicOverlayRef.value)
          let v = Cesium.Cartesian3.fromDegrees(0,0,5000);
          dynamicOverlayRef.value.trackOverlay(0, {
            mode,
            offset:{range: 8000},
            // viewFrom: [0, 0, 4720000]
           viewFrom:{lng:0,lat:0,height:8000}
          })
          shouldAnimate.value = true //这里被注释了，导致车子动不了
         
        }
  
        const isArray = Array.isArray;
        const isFunction = (val) => typeof val === 'function';
        const objectToString = Object.prototype.toString;
        const toTypeString = (value) => objectToString.call(value);
        const isPlainObject = (val) => toTypeString(val) === '[object Object]';
        function makeCartesian3(val, ellipsoid, isConstant = false) {
          const {
            CallbackProperty,
            Cartesian3,
            Ellipsoid,
            SampledPositionProperty,
            CompositePositionProperty,
            ConstantPositionProperty,
            TimeIntervalCollectionPositionProperty
          } = Cesium;
          if (val instanceof Cartesian3 || val instanceof CallbackProperty || val instanceof SampledPositionProperty || val instanceof CompositePositionProperty || val instanceof ConstantPositionProperty || val instanceof TimeIntervalCollectionPositionProperty) {
            return val;
          }
          ellipsoid = ellipsoid || Ellipsoid.WGS84;
          if (isPlainObject(val)) {
            if (hasOwn(val, "x") && hasOwn(val, "y") && hasOwn(val, "z")) {
              const value = val;
              return new Cartesian3(value.x, value.y, value.z);
            } else if (hasOwn(val, "lng") && hasOwn(val, "lat")) {
              const value = val;
              return Cartesian3.fromDegrees(value.lng, value.lat, value.height || 0, ellipsoid);
            }
          }
          if (isArray(val)) {
            return Cartesian3.fromDegrees(val[0], val[1], val[2] || 0, ellipsoid);
          }
          if (isFunction(val)) {
            return new CallbackProperty(val, isConstant);
          }
          return void 0;
        }
  
  
  
        const stopArrived = (overlay) => {
          console.log('到达站点：',overlay.position, overlay.position.position[0], overlay.position.position[1], overlay.position.position[2])
          // console.log('DynamicInspection.vue ledHostListDatas = ',ledHostListDatas);
          
          
          ledHostPoitions.forEach((element)=>{
            const stopPosition = makeCartesian3(element.position);
            const currentPosition = makeCartesian3(overlay.position.position); 
            const positionFlag = Cesium.Cartesian3.equalsEpsilon(currentPosition, stopPosition, 0.00035);
            if(positionFlag && !element.isChecked){
              element.isChecked = true ;
              console.log('if(positionFlag)= true overlay.position = ',overlay.position.position);
              console.log('element.position = ',element.position);
              shouldAnimate.value = false
              $bus.emit('LEDGpAddr',element.gprsAddr); 
                  
            }
          })
          
        }
  
        onMounted(()=>{
          axios.get('http://47.111.99.118:8089/system/HostList').then(
            response => {
              console.log('DynamicInspection组件 请求成功response.data = ',response.data);
              ledHostListDatas = response.data.data ;
              let ledPos = [] ;
              ledHostListDatas.forEach((element)=>{
                let pos = bd09_to_wgs84(element.lon ,element.lat);
                ledPos.push({isChecked:false,gprsAddr:element.gprsAddr,position:[pos.longitude,pos.latitude]});   
              })
              ledHostPoitions = ledPos;
              console.log('ledHostPoitions = ',ledHostPoitions);
            },
            error=>{
              console.log('DynamicInspection组件 请求失败了',error.message)
            })

            // 接收信号后该组件的相关设置显示
            // $bus.on('isShouldAnimate',(value)=>{
            //   shouldAnimate.value = value;  
            // })
            // $bus.on('startInspection',startInspection);
            // $bus.on('closeInspection',unload);
            // $bus.on('trackOverlay',trackOverlay);
        })
  
        return {
          dynamicOverlays,
          dynamicOverlayRef,
          currentTime,
          startTime,
          stopTime,
          clockRange,
          unload,
          load,
          reload,
          ready,
          // radio,
          // onRadioChanged,
          multiplier,
          viewTopDown,
          viewSide,
          trackOverlay,
          stops,
          showStop,
          stopArrived,
          shouldAnimate
        }
      }
    }
  
  </script>
  
  <style scoped>
  @import url("//unpkg.com/element-plus/dist/index.css");
  
  @import url("//unpkg.com/vue-cesium/dist/index.css");


.demo-viewer .el-row:last-child {
    margin-bottom: 0;
}

.demo-viewer .el-row {
    border-radius: 100px;
    align-items: baseline;
}

.demo-viewer .demo-toolbar {
    position: absolute;
    left: 1%;
    top: 1%;
    min-width: 185px;
    z-index: 100;
    color: #fff;
    background-color: rgba(0,0,0,.2);
}

/* .demo-vc-viewer .el-switch:first-child {
    margin-left: 20px;
}

.demo-vc-viewer .el-switch {
    margin: 20px 20px 20px 0;
}

.demo-vc-datasource-custom {
    .el-switch__label.is-active {
        color: #409eff;
    }
} */

/* .block {
    padding: 30px 24px;
    overflow: hidden;
    border-bottom: solid 1px #eff2f6;
    &:last-child {
        border-bottom: none;
    }
}

.el-row {
    border-radius: 100px;
    align-items: baseline;

    &:last-child {
    margin-bottom: 0;
    }
}
.el-button {
    margin: 10px 10px 10px 0;

    &:first-child {
    margin-left: 20px;
    }
}

.el-switch {
    margin: 20px 20px 20px 0;

    &:first-child {
    margin-left: 20px;
    }
}

.el-switch__label {
    color: white;
} */

</style>